import { useMutation } from '@apollo/client';
import type { VariablesOf } from '@graphql-typed-document-node/core';
import authTokenUtil from '../account/authTokenUtil';
import { gql } from '../graphql/generated/gql';

const UPDATE_PASSWORD_MUTATION = gql(/** @complexity 2 */ `
  mutation updatePassword($password: String!, $oldPassword: String) {
    updatePassword(password: $password, oldPassword: $oldPassword) {
      authToken
    }
  }
`);

const useUpdatePasswordMutation = () => {
  const [mutate] = useMutation(UPDATE_PASSWORD_MUTATION, {});

  return (variables: VariablesOf<typeof UPDATE_PASSWORD_MUTATION>) =>
    mutate({
      variables,
      onCompleted: (data) => {
        authTokenUtil.set(data.updatePassword.authToken);
      },
    });
};

export default useUpdatePasswordMutation;
